import { useMedia } from "react-use";
import { getBreakpoint } from "./mediaQueries";
// Check for mobile devices that have virtual keyboard
export var useIsMobileTouchDevice = function() {
    var isMobileTouchDevice = useMedia("(max-width: ".concat(getBreakpoint("md"), "px) and (pointer:coarse)"), false);
    return isMobileTouchDevice;
};
